// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"82":"99fc32d6","927":"4938e0a4"}[chunkId] + ".js";
};